import { Injectable } from '@angular/core';
import { GenericService } from '@messaia/cdk';

@Injectable({ providedIn: 'root' })
export class ImageService extends GenericService<any> {

	/**
	 * Constructor
	 */
	constructor() {
		super('image');
	}
}